import { UntypedFormControl, Validators } from '@angular/forms';

import { InputRegex } from '@forms/form-text-input/entities/input-mask';

export const MAXLENGTH_EMAIL_CONTROL = 50;
export const MAXLENGTH_PHONE_CONTROL = 20;

export const DEFAULT_EMAIL_CONTROL = new UntypedFormControl('', [
  Validators.required,
  Validators.minLength(3),
  Validators.maxLength(MAXLENGTH_EMAIL_CONTROL),
  Validators.email
]);

export const DEFAULT_PHONE_CONTROL = new UntypedFormControl('', [
  Validators.required,
  Validators.minLength(3),
  Validators.maxLength(MAXLENGTH_PHONE_CONTROL),
  Validators.pattern(InputRegex.NUMERIC)
]);
